import styled, {css} from "styled-components";
import {JackpotWidgetClockDefaultBox} from "./jackpot-widget-clock.default.box";

export const JackpotWidgetClockMrGreenBox = styled(JackpotWidgetClockDefaultBox)`
    color: ${({theme}) => theme.colors.textDark };

    ${({isDaily}) => isDaily ? css`
      ${({theme}) => theme.font.presets.bold};
      font-weight: 600;
      padding-bottom: 0;
    ` : null};
`;
